import React from 'react';
import NetworkInfo from "./NetworkInfo";
import DetailsPageHeader from "../../components/common/headers/DetailsPageHeader";
import {useLoaderData} from "react-router-dom";
import {usePreloadedQuery} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {useUser} from "../../hooks/useUser";
import Attachments from "../../components/attachments/Attachments";
import {Col, Row} from "react-bootstrap";
import Notes from "../../components/notes/Notes";

const NetworkDetails = () => {
    const loader = useLoaderData();
    const data = usePreloadedQuery(graphql`
        query NetworkDetailsQuery($id: ID!) {
            node(id: $id) {
                id
                ... on Network {
                    name,
                    ...NetworkInfo_Network
                    contracts {
                        ...ContractsTable_Contract
                    }
                    attachments {
                        ...Attachments
                    }
                    notes {
                        ...Notes
                    }
                }
            }
            allNetworkOwners {
                ...NetworkOwnersFragments_AllNetworkOwnersDropdown
            }
            allAttachmentCategories {
                ...Fragments_AllAttachmentCategoriesDropdown
            }
        }
    `, loader.networkDetailsQuery)
    const {hasPermission} = useUser();
    return (
        <>
            <DetailsPageHeader title={data.node.name} iconType={"network-wired"} iconText={"Network"} />
            <Row className={"mb-3"}>
                <Col md={5}>
                    <NetworkInfo network={data.node} networkOwners={data.allNetworkOwners} />
                </Col>
                {hasPermission("NetworkNote.Read") && <Col>
                    <Notes paginationSize={2}
                           notes={data.node.notes}
                           createPermission={"NetworkNote.Create"}
                           editPermission={"NetworkNote.Update"}
                           deletePermission={"NetworkNote.Delete"}
                           parentId={data.node.id}
                    />
                </Col>}
            </Row>
            {hasPermission("NetworkAttachment.Read") && <Attachments 
                attachmentCategories={data.allAttachmentCategories}
                parentId={data.node.id}
                attachments={data.node.attachments}
                createPermission={"NetworkAttachment.Create"}
                deletePermission={"NetworkAttachment.Delete"}
            /> }
        </>
    );
};

export default NetworkDetails;
